/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * LayoutShell.tsx — Layou\1 \2hell (services/operator-web-app).
 */

import { Outlet } from 'react-router-dom';
import {
  usePresenceHeartbeat,
  usePresenceOfflineSignal,
  useReconnectOnVisible,
  useAutoConnect,
  ConnectionStatusBanner,
} from '@/features/presence';
import { IncomingCallOverlay } from '@/features/call';
import { ToastContainer } from '@/components/ToastContainer';
import { OnboardingWizard } from '@/features/onboarding';
import { TopBar } from './TopBar';
import { LeftRail } from './LeftRail';
import { CenterWorkspace } from './CenterWorkspace';
import { RightCopilot } from './RightCopilot';
import { useTranslation } from '@/i18n';

/**
 * Desktop-first shell: TopBar, LeftRail, CenterWorkspace, RightCopilot.
 * Plan: 02_information_architecture, 14_wireframes.
 * Breakpoints: lg (1024) = left+center, xl (1280) = + right panel.
 */
export function LayoutShell() {
  const t = useTranslation();
  useAutoConnect();
  usePresenceHeartbeat();
  usePresenceOfflineSignal();
  useReconnectOnVisible();

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        background:
          'linear-gradient(135deg, var(--bg-gradient-from), var(--bg-gradient-via), var(--bg-gradient-to))',
      }}
    >
      <a
        href="#main-content"
        className="skip-link fixed left-2 top-2 z-[100] -translate-y-full rounded-md bg-emerald-600 px-4 py-2 text-sm font-medium text-white shadow-lg transition-transform focus:translate-y-0 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
      >
        {t('shell.skip_content')}
      </a>
      <ConnectionStatusBanner />
      <TopBar />
      <div className="flex-1 flex min-h-0">
        <LeftRail />
        <CenterWorkspace>
          <Outlet />
        </CenterWorkspace>
        <RightCopilot />
      </div>
      <ToastContainer />
      <IncomingCallOverlay />
      <OnboardingWizard />
    </div>
  );
}
